<template>
  <div>
    <div v-if="isConnected">
      <b-button @click="signOut" :loading="isSigningOut" :size="size">Sign Out</b-button>
    </div>
    <div v-else>
      <b-button type="is-primary" @click="signIn" :loading="isSigningIn" :size="size">Sign In</b-button>
    </div>
  </div>
</template>

<script>
import { signIn, signOut } from '@/firebase.js'
import { routes } from '@/constants.js'

export default {
  name: 'sign-button',
  props: {
    size: String
  },
  computed: {
    isSigningIn () {
      return this.$store.state.isSigningIn
    },
    isSigningOut () {
      return this.$store.state.isSigningOut
    },
    isConnected () {
      return this.$store.state.isConnected
    }
  },
  methods: {
    async signIn () {
      await signIn()
      if (this.$route.query.redirect && this.$route.query.redirect !== '') {
        this.$router.push(this.$route.query.redirect)
      } else {
        this.$router.push({ name: routes.manage })
      }
    },
    async signOut () {
      await signOut()
      this.$router.push({ name: routes.home })
    }
  }
}
</script>
